/* eslint-disable react/no-array-index-key */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import TrackingEvent, { trackingEventType } from '../items/TrackingEvent';
import getFormattedTrackingEvents from '../../lib/getFormattedTrackingEvents';

const propTypes = {
    items: PropTypes.arrayOf(trackingEventType),
    className: PropTypes.string,
};

const defaultProps = {
    items: [],
    className: null,
};

const TrackingEventsList = ({ items, className }) => {
    const finalItems = useMemo(() => getFormattedTrackingEvents(items), [items]);
    return (
        <div
            className={classNames([
                {
                    [className]: className !== null,
                },
            ])}
        >
            <table className={classNames(['table'])}>
                <thead>
                    <tr>
                        <th scope="col">
                            <FormattedMessage
                                defaultMessage="Action"
                                description="Action tracking event column"
                            />
                        </th>
                        <th scope="col">
                            <FormattedMessage
                                defaultMessage="Content"
                                description="Content tracking event column"
                            />
                        </th>
                        <th scope="col">
                            <FormattedMessage
                                defaultMessage="Count"
                                description="Count tracking event column"
                            />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {finalItems.map((item, index) => (
                        <TrackingEvent key={`event-${index}`} item={item} />
                    ))}
                    {finalItems.length === 0 ? (
                        <tr>
                            <td colSpan="3">
                                <FormattedMessage
                                    defaultMessage="No events"
                                    description="No events tracking row"
                                />
                            </td>
                        </tr>
                    ) : null}
                </tbody>
            </table>
        </div>
    );
};

TrackingEventsList.propTypes = propTypes;
TrackingEventsList.defaultProps = defaultProps;

export default TrackingEventsList;
